module.exports = __webpack_public_path__ + "img/亲亲.3e745d29.png";